import React__default, { forwardRef } from 'react';
import { Type } from '../../../marks/bold/BoldPlugin.mjs';
import { Type as Type$1 } from '../../../marks/italic/ItalicPlugin.mjs';
import { Type as Type$2 } from '../../../marks/strikethrough/StrikethroughPlugin.mjs';
import { Type as Type$3 } from '../../../marks/underline/UnderlinePlugin.mjs';
import { Type as Type$4 } from '../../../marks/textColor/TextColorPlugin.mjs';

const TextStyle = /*#__PURE__*/forwardRef(function TextStyle({
  marks: {
    [Type]: bold,
    [Type$1]: italic,
    [Type$2]: strikethrough,
    [Type$3]: underline,
    [Type$4]: textcolor
  },
  children,
  ...props
}, ref) {
  return /*#__PURE__*/React__default.createElement("span", Object.assign({
    ref: ref,
    style: {
      color: textcolor ? textcolor : undefined,
      fontWeight: bold ? 'bold' : undefined,
      fontStyle: italic ? 'italic' : undefined,
      textDecoration: inline([underline ? 'underline' : undefined, strikethrough ? 'line-through' : undefined])
    }
  }, props), children);
});
function inline(array) {
  return array.filter(Boolean).join(' ');
}

export { TextStyle };
